import * as THREE from 'three';
import {GUI} from 'three/examples/jsm/libs/lil-gui.module.min';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader';
import {
  CSS3DRenderer,
  CSS3DSprite,
} from 'three/examples/jsm/renderers/CSS3DRenderer.js';

export default class ZThree {
  constructor (id) {
    this.id = id;
    this.el = document.getElementById (id);
  }

  initThree () {
    let width = this.el.offsetWidth;
    let height = this.el.offsetHeight;
    this.scene = new THREE.Scene ();
    this.textureLoader = new THREE.TextureLoader ();
    this.camera = new THREE.PerspectiveCamera (45, width / height, 1, 1000);
    this.camera.position.set (30, 30, 30);
    this.camera.lookAt (0, 0, 0);
    this.renderer = new THREE.WebGLRenderer ({
      antialias: true,
      alpha: true,
    });
    this.renderer.setPixelRatio (window.devicePixelRatio);
    this.renderer.setSize (width, height);
    this.el.appendChild (this.renderer.domElement);

    this.css3Renderer = new CSS3DRenderer ();
    this.css3Renderer.setSize (width, height); // 设置渲染器尺寸
    this.css3Renderer.domElement.style.position = 'absolute'; // 设置渲染器样式
    this.css3Renderer.domElement.style.top = '0'; // 设置渲染器样式
    this.el.appendChild (this.css3Renderer.domElement); // 将渲染器挂载到页面上

    this.gui = new GUI ();
    window.addEventListener ('resize', () => {
      this.camera.aspect = this.el.offsetWidth / this.el.offsetHeight;
      this.camera.updateProjectionMatrix ();
      this.renderer.setSize (this.el.offsetWidth, this.el.offsetHeight);
      if (this.css3Renderer) {
        this.css3Renderer.setSize (this.el.offsetWidth, this.el.offsetHeight);
      }
    });
  }

  initLight () {
    const directionalLight = new THREE.DirectionalLight (0xffffff, 0.5);
    this.scene.add (directionalLight);

    const ambientLight = new THREE.AmbientLight (0x404040); // soft white light
    this.scene.add (ambientLight);
    // 添加雾效果
    // const fog = new THREE.Fog (new THREE.Color (0xa0a0a0), 500, 2000);
    // this.scene.fog = fog;
  }

  initHelper () {
    this.scene.add (new THREE.AxesHelper (100));
  }

  initOrbitControls () {
    let controls = new OrbitControls (
      this.camera,
      this.css3Renderer.domElement
    );
    controls.enableDamping = true;
    controls.enableZoom = true;
    controls.autoRotate = true;
    controls.autoRotateSpeed = 0.5;
    controls.enablePan = true;
    this.controls = controls;
  }

  loaderModel (option) {
    switch (option.type) {
      case 'glb':
      case 'gltf':
        if (!this.gltfLoader) {
          this.gltfLoader = new GLTFLoader ();
          let dracoLoader = new DRACOLoader ();
          dracoLoader.setDecoderPath ('draco/');
          this.gltfLoader.setDRACOLoader (dracoLoader);
        }
        this.gltfLoader.load (
          option.url,
          option.onLoad,
          option.onProgress,
          option.onError
        );
        break;
      case 'obj':
        break;
      default:
        break;
    }
  }

  iterateLoad (objFileList, onProgress, onAllLoad) {
    let fileIndex = 0;
    let that = this;
    function iterateLoadForIt () {
      that.loaderModel ({
        type: objFileList[fileIndex].type,
        url: objFileList[fileIndex].url,
        onLoad: object => {
          if (objFileList[fileIndex].onLoad) {
            objFileList[fileIndex].onLoad (object);
          }

          fileIndex++;
          if (fileIndex < objFileList.length) {
            iterateLoadForIt ();
          } else {
            onAllLoad ();
          }
        },
        onProgress: xhr => {
          if (objFileList[fileIndex].onProgress) {
            objFileList[fileIndex].onProgress (xhr);
          }
          if (onProgress) {
            onProgress (xhr);
          }
        },
        onError: error => {
          console.error (error);
        },
      });
    }
    iterateLoadForIt ();
  }

  render (callback) {
    callback ();
    this.frameId = requestAnimationFrame (() => {
      this.render (callback);
    });
  }
}
